import AccountLayout from '@components/profile/layout/AccountLayout'

Orders.Layout = AccountLayout

export default function Orders() {
	return null
}
